/* eslint-disable no-plusplus */
/* eslint-disable react/react-in-jsx-scope */
import React from 'react'

import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    fontSize: 20,
    marginBottom: 10,
  },
  daysRemaining: {
    fontSize: 14,
    marginBottom: 10,
  },
  message: {
    fontSize: '16px',
    marginBottom: theme.spacing(1),
    fontWeight: 400,
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  container: {
    position: 'relative',
    padding: 16,
  },
  closeButton: {
    position: 'absolute',
    top: 12,
    right: 12,
    background: 'transparent',
    border: 'none',
    fontSize: 20,
    fontWeight: 600,
    cursor: 'pointer',
    lineHeight: 1,
    color: '#000',
  },
}))

export default function ManagementInfo({ title, date, daysRemaining, body, onClose }) {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <button type="button" className={classes.closeButton} onClick={onClose}>
        ×
      </button>
      <Typography className={classes.dialogTitle}>{title}</Typography>
      <Typography variant="body2" className={classes.message}>
        {body}
      </Typography>
      <div className={classes.footer}>
        <Typography variant="body2" className={classes.message}>
          {date || ''}
        </Typography>
        {daysRemaining && (
          <Typography className={classes.daysRemaining}>
            {`Reactivación en ${daysRemaining} días`}
          </Typography>
        )}
      </div>
    </div>
  )
}
